<script>
    import IconButton, {Icon} from "@smui/icon-button"
    import List, {Group, Item, Graphic, Meta, Label, Separator, Subheader, Text, PrimaryText, SecondaryText} from '@smui/list';
	import Menu, {SelectionGroup, SelectionGroupIcon} from "@smui/menu";
    
    export let filters;
    export let hackStyle = "";
    export let anchorCorner = "TOP_RIGHT";

    let contextMenu = null;
</script>

<IconButton class="material-icons" on:click={()=>{
    if (filters.length == 0) {
        filters.addSet();
    }
    else {
        contextMenu.setOpen(true);
    }
}}>{#if filters.length == 0}add{:else}edit{/if}</IconButton>
<div style={hackStyle}> <!-- filthy hack! -->
    <Menu bind:this={contextMenu} anchorCorner={anchorCorner}>
        <List>
            {#if filters.multisetEnabled}
                <Item on:SMUI:action={()=>{ filters.addSet(); }}><Text>Add Condition Set</Text></Item>
            {/if}
            <Item on:SMUI:action={()=>{ filters.reset(); }}><Text>Clear</Text></Item>
        </List>
    </Menu>
</div>